export const UPDATE_MESSAGES = "UPDATE_MESSAGES";

export const updateMessages = (value) => ({
  type: UPDATE_MESSAGES,
  value,
});
